<template>
  <div class="form-group">
    <label :for="id" class="glass-label">
      {{ label }}
      <span v-if="required" class="visually-hidden">Requis</span>
    </label>
    <input
      :id="id"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      class="glass-input"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :aria-required="required"
      :aria-invalid="modelValue && type === 'email' && !isValidEmail(modelValue) ? 'true' : 'false'"
    />
  </div>
</template>

<script>
export default {
  name: 'InputComponent',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isValidEmail(email) {
      // Validation basique d'email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    }
  }
}
</script>

<style scoped>
::placeholder {
  color: var(--c-white);
  opacity: 0.8;
  font-style: italic;
}
</style>
